/**
 * Calendar sync state (MFD-404).
 *
 * The backend reports a calendar whose OAuth token could not be auto-renewed
 * via `needs_reconnect`, camelCased to `needsReconnect` by the API layer.
 * Treating the mere presence of an integration row as "connected" is what made
 * an expired calendar keep showing a tick, and what routed a user who clicked
 * the icon to reconnect into the unlink dialog instead.
 */

export const CONNECT = 'connect';
export const RECONNECT = 'reconnect';
export const UNLINK = 'unlink';

/**
 * Sync state of one provider, from the list the API returned.
 */
export const calendarStateFor = (integrations, provider) => {
  const integration = (integrations || []).find(ci => ci.provider === provider);
  return {
    connected: Boolean(integration),
    needsReconnect: Boolean(integration && integration.needsReconnect),
  };
};

/**
 * What clicking a provider's icon should do.
 *
 * An expired calendar reconnects rather than unlinks — the user is following a
 * prompt telling them to click it to reconnect, so unlinking would be the
 * opposite of what they asked for.
 */
export const clickActionFor = ({connected, needsReconnect} = {}) => {
  if (!connected) {
    return CONNECT;
  }
  return needsReconnect ? RECONNECT : UNLINK;
};

/**
 * Whether to show the "your calendar sync has expired" prompt.
 */
export const hasExpiredSync = calendars =>
  (calendars || []).some(c => c.connected && c.needsReconnect);
